export const REDUX_PERSIST_KEY = "ohc";

// export const NODE_ENV = "development";

// export const API_URL =
//     NODE_ENV === "production"
//         ? "https://api-securetext-staging.weavers-web.com/v1"
//         : NODE_ENV === "development"
//             ? "https://api-securetext.weavers-web.com/v1"
//             : "http://localhost:4000/v1";

export const API_LIVE_URL = process.env.REACT_APP_API_URL;
